import { createSelector } from 'reselect';
import * as fromReportDbtMetadata from './report-dbt-metadata.reducer';

export interface ReportDbtMetadataDomainState {
  [fromReportDbtMetadata.reportDbtMetadataFeatureKey]: fromReportDbtMetadata.ReportDbtMetadataFeatureState;
}

export const selectReportDbtMetadataState = (state: ReportDbtMetadataDomainState) =>
  state[fromReportDbtMetadata.reportDbtMetadataFeatureKey];

export const getReportDbtMetadata = createSelector(
  selectReportDbtMetadataState,
  (reportDbtMetadata) => reportDbtMetadata.dbtMetaData
);

export const getReportDbtMetadataLoading = createSelector(
  selectReportDbtMetadataState,
  (ReportDbtMetadata) => ReportDbtMetadata.isLoading
);

export const getIsComplete = createSelector(selectReportDbtMetadataState, (state) => state.isComplete);
export const getError = createSelector(selectReportDbtMetadataState, (state) => state.error);
